import { createReducer, on } from '@ngrx/store';
import { setLoading } from '../actions/loading.actions';

export interface LoadingState {
  isLoading: boolean;
}

export const initialState: LoadingState = {
  isLoading: false,
};

export const loadingReducer = createReducer(
  initialState,
  on(setLoading, (state, { isLoading }) => ({ ...state, isLoading }))
);
